// LaViola.it Brand Colors
export const Colors = {
  // Primary
  primary: '#441274',
  primaryDark: '#330d57',
  primaryLight: '#6b3fa0',
  primaryPastel: '#E8DEFF', // Light pastel purple for badges

  // Background
  background: '#F5F5F5',
  surface: '#FFFFFF',
  surfaceVariant: '#F0F0F0',

  // Text
  textPrimary: '#1A1A1A',
  textSecondary: '#666666',
  textOnPrimary: '#FFFFFF',

  // Border & Divider
  border: '#E0E0E0',
  divider: '#EEEEEE',

  // Status
  success: '#4CAF50',
  error: '#E53935',
  warning: '#FF9800',
  info: '#2196F3',
};
